export const COLUMNS_NUMBER_TO_CHANGE_LAYOUT = 3;
